import { create } from "zustand";

export const useTooltipFootnoteStore = create((set, get) => ({
  data: {},
  setData: (value) => set({ data: { ...get().data, ...value } }),
  getData: () => get().data,

  resetStore: () => {
    set({
      data: {},
    });
  },
}));
